import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import Contact from './pages/Contact';
import Projects from './pages/Projects';
import Vulcan from './pages/Vulcan';
import Astra from './pages/Astra';

import { Toaster } from './components/ui/toaster';
import { ThemeProvider } from './context/ThemeContext';

import ScrollToTop from './components/ScrollToTop';
import ScrollToTopOnRouteChange from './components/ScrollToTopOnRouteChange';

import './App.css';

function App() {
  // Let the browser restore scroll position on back/forward
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  return (
    <ThemeProvider>
      <BrowserRouter>
        {/* Resets scroll on every route change */}
        <ScrollToTopOnRouteChange />

        {/* Floating scroll-to-top button */}
        <ScrollToTop />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/vulcan" element={<Vulcan />} />
          <Route path="/astra" element={<Astra />} />
        </Routes>

        <Toaster />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;